import { get, post, put } from "./api_helper"

export const getFabricTradingAPI = params =>
  get("admin/master/fabric-trading-company/page", params)

export const getFabricTradingListAPI = () =>
  get("admin/master/fabric-trading-company/list")

export const getFabricTradingByIdAPI = id =>
  get(`admin/master/fabric-trading-company/${id}`)

export const postFabricTradingAPI = data =>
  post("admin/master/fabric-trading-company", data)

export const putFabricTradingAPI = (data, id) =>
  put(`admin/master/fabric-trading-company/${id}`, data)
